import styled from 'styled-components';

export default styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #FFF;
  border-radius: 0.3rem;
  ${props => !props.$transitionDisabled && 'transition: width 250ms linear;'}
`;
